module.exports = __webpack_public_path__ + "img/btn-submit-2.59a6c091.png";